/**
 * Auth0 sign-in settings, from the build's environment (`.env`). They are public: the domain
 * and client ID identify the tenant and this site, and the audience names the API the access
 * token is for. Without them, sign-in is off and the Log in button is hidden.
 */
export const auth0 = {
  domain: import.meta.env.VITE_AUTH0_DOMAIN as string | undefined,
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID as string | undefined,
  audience: import.meta.env.VITE_AUTH0_AUDIENCE as string | undefined,
}

export const authEnabled = Boolean(
  auth0.domain && auth0.clientId && auth0.audience,
)
